import classNames from "classnames";
import { handleMetaClick } from "neetocommons/react-utils";
import { hyphenize } from "neetocommons/utils/general";
import { Home } from "neetoicons";
import { Typography, Button } from "neetoui";
import { omit } from "ramda";
import { useHistory } from "react-router-dom";

import { DEFAULT_HOME_PATH } from "components/Sidebar/constants";

import Items from "./Items";

const SelectedLink = ({
  navLink = { label: "", items: [], isConfigureNavLink: false },
  handleGoBack,
  isConfigureSidebar,
}) => {
  const history = useHistory();
  const { label, items, isConfigureNavLink, ...otherProps } = navLink;

  const handleHomeButtonClick = e => {
    e.stopPropagation();
    handleMetaClick(history, DEFAULT_HOME_PATH, e);
  };

  return (
    <div
      className="neeto-molecules-sidebar__links neeto-molecules-sidebar__links--focus-mode neeto-molecules-sidebar__no-shrinkable"
      data-testid="configure-nav-container"
    >
      <div
        className="neeto-ui-flex neeto-ui-items-center neeto-ui-no-underline neeto-molecules-sidebar__link neeto-ui-border-b neeto-ui-border-gray-200"
        onClick={handleGoBack}
        {...{ ...omit(["icon"], otherProps) }}
      >
        {isConfigureNavLink && (
          <span className="neeto-molecules-sidebar__link-icon flex items-center pl-3">
            <Button
              data-testid={`${hyphenize(label)}-go-back-button`}
              icon={Home}
              style="text"
              onClick={handleHomeButtonClick}
            />
            <span className="px-1 text-xs">/</span>
          </span>
        )}
        <Typography
          component="span"
          style="body1"
          className={classNames("neeto-molecules-sidebar__link-label", {
            "neeto-molecules-sidebar__configure-page-header":
              isConfigureNavLink,
            ["pl-4"]: isConfigureSidebar,
          })}
        >
          {label}
        </Typography>
      </div>
      {items && <Items {...{ items }} isSettingsItems />}
    </div>
  );
};

export default SelectedLink;
